/**
 * BrandingContext — fetches active white-label profile from /api/branding/active
 * once on app mount and exposes it via useBranding(). Changing the active brand
 * (via /app/scripts/swap_bank_brand.sh) requires no React rebuild — a hard
 * refresh re-fetches the profile.
 *
 * Default fallback matches the Seacoast profile so first paint never shows
 * unbranded placeholders even if the API is briefly unreachable.
 */
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const DEFAULT_BRAND = {
  slug: "seacoast",
  name: "Seacoast Bank",
  walletName: "Seacoast Pay",
  domain: "seacoastbank.com",
  insurance: "FDIC",
  insuranceLabel: "FDIC Insured",
  type: "bank",
  primaryColor: "#007377",
  secondaryColor: "#0F766E",
  accentColor: "#14B8A6",
  logoUrl: null,
  tagline: "",
  supportEmail: "",
  supportPhone: "",
};

const BrandingContext = createContext(DEFAULT_BRAND);

export const BrandingProvider = ({ children }) => {
  const [brand, setBrand] = useState(DEFAULT_BRAND);

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    axios
      .get(`${API}/api/branding/active`)
      .then((res) => {
        if (res?.data) setBrand(res.data);
        // Update document title in real time on swap
        if (res?.data?.walletName) document.title = res.data.walletName;
      })
      .catch(() => {
        /* keep default */
      });
  }, []);

  return <BrandingContext.Provider value={brand}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
